import type { GetCustomerRevenueReportResponsePayload } from '@vy/api-definition';
import { GetCustomerRevenueReportResponseSchema } from '@vy/api-definition';
import { validateNotNullOrUndefined } from '@vy/utils';
import { useCallback } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

async function customerRevenueReportQuery() {
  const api = getPrivateApi();
  const customerRevenueReport = await api.getCustomerRevenueReport();

  return GetCustomerRevenueReportResponseSchema.parse(customerRevenueReport);
}

export function useCustomerRevenueReport(
  options?: CustomUseQueryOptions<GetCustomerRevenueReportResponsePayload>,
) {
  const getCustomerRevenueReportQuery = useQuery(
    queryKeys.customerRevenueReport(),
    () => customerRevenueReportQuery(),
    {
      suspense: true,
      ...options,
    },
  );

  validateNotNullOrUndefined(getCustomerRevenueReportQuery.data, 'getCustomerRevenueReportQuery data');

  return getCustomerRevenueReportQuery;
}

export function useRefreshCustomerRevenueReport() {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    const data = await customerRevenueReportQuery();
    queryClient.setQueryData(queryKeys.customerRevenueReport(), data);
  }, [queryClient]);
}

